import {SSRRuleListItem} from '../../../../integrated-client/models/';

interface ITableData {
  records: Array<SSRRuleListItem>
}

export class TableData implements ITableData{
  records: Array<SSRRuleListItem>

  constructor() {
    this.records = [];
  }
}
